import {
  TABLE_CELL_WIDTH,
  TABLE_FIRST_CELL_WIDTH,
  TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO,
  TABLE_WIDTH,
} from "../../../constant";

export class PDFPortfolioFeeTableConfigs {
  static readonly MaxProductsDisplay = 5;
  static readonly DefaultFontSize = 7;
  static readonly FirstCellWidth = TABLE_FIRST_CELL_WIDTH + TABLE_CELL_WIDTH;
  static readonly FollowingCellWidth =
    (TABLE_WIDTH - this.FirstCellWidth) / this.MaxProductsDisplay;
  static readonly TableHeaderHeight = TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO + 5;
  static readonly TableFooterHeight = 20;
  static readonly TableTitleHeight = 20;
  static readonly SectionGapHeight = 30;
  static readonly DefaultRowHeight = 16;
  static readonly RowHeightLinesMultiplier = 7.25;
  static readonly DefaultMaxCharsPerLine = 30;
  static readonly DefaultMaxCharsPerLineOfValue = 10;
  static readonly NoDataSectionHeight = 85;
}
